import { useHolidayStore } from '@/store/useHolidayStore';

const ASSET_PATH = '/christmas-tree-campaign';

interface DecorationConfig {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  zIndex: number;
}

interface DecorationItemProps {
  decoration: DecorationConfig;
  canvasSize: { width: number; height: number };
  animationDelay?: number;
}

// Map decoration IDs to filenames (handle spaces and special chars)
const getFilename = (id: string): string => {
  // Most decoration IDs match their filenames
  return `${id}.svg`;
};

export function DecorationItem({ decoration, canvasSize, animationDelay = 0 }: DecorationItemProps) {
  const { activeDecoration, triggerDecoration } = useHolidayStore();

  const isAnimating = activeDecoration === decoration.id;
  const filename = getFilename(decoration.id);

  // Calculate percentage positions
  const leftPercent = (decoration.x / canvasSize.width) * 100;
  const topPercent = (decoration.y / canvasSize.height) * 100;
  const widthPercent = (decoration.width / canvasSize.width) * 100;
  const heightPercent = (decoration.height / canvasSize.height) * 100;

  const handleClick = () => {
    triggerDecoration(decoration.id);
  };

  return (
    <img
      src={`${ASSET_PATH}/${filename}`}
      alt={decoration.id}
      className={`
        absolute cursor-pointer select-none
        transition-transform duration-100
        hover:scale-105
        animate-decoration-glow
        ${isAnimating ? 'animate-decoration-wiggle' : ''}
      `}
      style={{
        zIndex: decoration.zIndex,
        left: `${leftPercent}%`,
        top: `${topPercent}%`,
        width: `${widthPercent}%`,
        height: `${heightPercent}%`,
        animationDelay: `${animationDelay}s`,
      }}
      onClick={handleClick}
      draggable={false}
    />
  );
}
